import SearchIcon from '@mui/icons-material/Search'
import React from 'react'
import { buttonStyleSx } from './HeaderSearchButton.styles'

import LoadingButton from '@mui/lab/LoadingButton'

interface HeaderSearchButtonProps {
  isLoading?: boolean
  buttonText: string
  onClick?: () => void
}
/**
 * HeaderSearchButton
 * @param buttonText
 * @constructor
 */
export const HeaderSearchButton: React.FC<HeaderSearchButtonProps> = ({
  isLoading = false,
  buttonText = 'Search',
  onClick,
}) => {
  return (
    <LoadingButton
      type={'submit'}
      variant={'contained'}
      startIcon={<SearchIcon />}
      sx={buttonStyleSx}
      onClick={onClick}
      loading={isLoading}
    >
      {buttonText}
    </LoadingButton>
  )
}
